<main class="container-fluid">
    <article class="gutter-row flex flex-col justify-center min-h-screen background-container" id="contactUs">
        <div class="max-w-[1200px] mx-auto bg-white p-8 shadow-md">
            <div class="text-start mb-8">
                <div class="text-primary text-2xl font-semibold mb-6 flex items-center">
                    <i nz-icon nzType="arrow-left" class="text-primary cursor-pointer mr-3 hover:text-blue-700 transition-colors" (click)="location.back()"></i>
                    <span>Contact Us</span>
                </div>
                
                <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mt-6">
                    <div>
                        <div class="flex items-center mb-4">
                            <i nz-icon nzType="environment" class="text-primary text-xl mr-3"></i>
                            <h3 class="text-xl font-semibold text-gray-800">Our Office</h3>
                        </div>
                        <address class="text-gray-600 not-italic ml-8">
                            <p class="address_details mb-1" *ngFor="let line of config.address | keyvalue">
                                {{ line.value }}
                            </p>
                        </address>
                    </div>
                    <div>
                        <div class="flex items-center mb-4">
                            <h3 class="text-xl font-semibold text-gray-800">Get in Touch</h3>
                        </div>
                        <div>
                            <div class="flex items-center mb-4">
                                <i nz-icon nzType="phone" class="text-primary text-lg mr-3 rotate-180"></i>
                                <a href="tel:+919137524915" class="text-primary hover:underline flex items-center"
                                    aria-label="Call our support team">
                                    <span class="text-gray-600">{{ config.phone }}</span>
                                </a>
                            </div>
                            <div class="flex items-center mb-4">
                                <i nz-icon nzType="mail" class="text-primary text-lg mr-3"></i>
                                <a href="mailto:support@hezkytech.com" class="text-primary hover:underline" aria-label="Email our support team">
                                    {{supportEmail}}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>
</main>